const UTMFieldNames = {
  utm_medium: 'UTM Subscription Medium',
  utm_source: 'UTM Subscription Source',
  utm_campaign: 'UTM Subscription Campaign',
  utm_content: 'UTM Subscription Content',
  utm_term: 'UTM Subscription Term'
};

export { UTMFieldNames as default, UTMFieldNames };
